import React from 'react'
import { BaseErrorDisplay } from './BaseErrorDisplay'
import emailSvg from '../icons/email-success.svg'

export const UnverifiedEmailError = () => (
  <BaseErrorDisplay
    title="Email verification required"
    subtitle="PENDING EMAIL VERIFICATION"
    description="Please check your email and complete email verification before signing in."
    imgSrc={emailSvg}
    showSupport={false}
  />
)
